export default __webpack_public_path__ + "static/media/puppyMaleBlack.e76f8dab.jpg";